import { createApp } from 'vue';
import App from './App.vue';
import '@vuesax-next-ru/theme';

const app = createApp(App);
app.mount('#app');
